export const MAX_CONTACT_AMOUNT = 10;

export const RELATION_VALUES = [
  'AVOPUOLISO',
  'AVIOPUOLISO',
  'PUOLISO',
  'MUU',
  'ISA',
  'POIKA',
  'AITI',
  'TYTAR',
  'REKISTEROITY_PARISUHDE',
  'PERHEENJASEN',
  'SIJAISVANHEMPI',
  'SOSIAALITYONTEKIJA',
  'TUKIHENKILO',
];
